import type { Budget, BudgetTotals } from "@shared/types";

/**
 * Pure budget aggregation. Replaces the inline `.reduce(...)` calculations
 * scattered across Dashboard, Budget, etc. Phase 1 will swap call sites to
 * use this; for now, lives here as the canonical implementation.
 */
export function totalEstimated(budget: Budget): number {
  return budget.reduce((sum, c) => sum + c.estimated, 0);
}

export function totalActual(budget: Budget): number {
  return budget.reduce((sum, c) => sum + c.actual, 0);
}

export function variance(budget: Budget): number {
  return totalEstimated(budget) - totalActual(budget);
}

export function totals(budget: Budget): BudgetTotals {
  const estimated = totalEstimated(budget);
  const actual = totalActual(budget);
  return { estimated, actual, variance: estimated - actual };
}

export function costPerSqFt(budget: Budget, sqFt: number): number {
  if (sqFt <= 0) return 0;
  return Math.round(totalEstimated(budget) / sqFt);
}
